/**
 * Batched lookup of which EndoEdge box uploaded each study, resolved to
 * the human site name. Backs the "Source box" column on the worklist /
 * studies / reading tables. Mirrors the /studies/counts fetch.
 */
export interface StudySource { box: string; site: string | null }

export async function fetchStudySources(uids: string[]): Promise<Record<string, StudySource>> {
  const out: Record<string, StudySource> = {};
  const ids = uids.filter(Boolean);
  if (ids.length === 0) return out;
  const a = JSON.parse(sessionStorage.getItem("vpd.auth.v1") ?? "null");
  for (let i = 0; i < ids.length; i += 500) {
    const slice = ids.slice(i, i + 500);
    const r = await fetch("/viewer-api/studies/sources", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${a?.accessToken ?? ""}` },
      body: JSON.stringify({ uids: slice }),
    });
    if (!r.ok) continue;
    Object.assign(out, await r.json() as Record<string, StudySource>);
  }
  return out;
}

/** Human label for a study's source box (site name, else "Box <id>"). */
export function sourceLabel(s?: StudySource): string {
  return s ? (s.site || `Box ${s.box}`) : "—";
}
